module.exports = __webpack_public_path__ + "img/ky-lcsyt.73cee4be.png";